import { flexRender, useReactTable, getCoreRowModel } from "@tanstack/react-table";
import React, { useMemo } from "react";
import { Table } from "react-bootstrap";

export default function DetailsTable({ data, columns, className = "" }) {
	const dataArray = useMemo(() => (data ? [data] : []), [data]);
	
	const table = useReactTable({
		data: dataArray,
		columns: columns,
		getCoreRowModel: getCoreRowModel(),
	});

	return (
		<Table size="sm" borderless className={`m-0 w-100 ${className}`}>
			<thead>
				{table.getHeaderGroups().map((headerGroup) => (
					<tr key={headerGroup.id}>
						{headerGroup.headers.map((header) => (
							<th key={header.id} className="fw-bold col-2 p-0">
								{flexRender(header.column.columnDef.header, header.getContext())}
							</th>
						))}
					</tr>
				))}
			</thead>
			<tbody>
				{table.getRowModel().rows.map((row, i) => (
					<tr key={i}>
						{row.getVisibleCells().map((cell, index) => (
							<td
								key={index}
								style={{ width: cell.column.getSize() }}
								className="p-0"
							>
								{flexRender(cell.column.columnDef.cell, cell.getContext())}
							</td>
						))}
					</tr>
				))}
			</tbody>
		</Table>
	);
}
